import { RootState } from '../../reducers';
import { Application } from '@raydiant/api-client-js';

export interface ApplicationsById {
  [applicationId: string]: Application | undefined;
}

export const selectApplicationsById = (state: RootState): ApplicationsById =>
  state.v2Applications.byId;
